export default __webpack_public_path__ + "static/media/logo.951ad035.png";